export const MEDIA_QUERIES = {
  GET_MEDIA_INFERENCES: `
    query GetMediaInferences($personaId: ID!, $limit: Int!, $cursor: String, $isNSFW: Boolean, $mediaType: String) {
      mediaInferences(personaId: $personaId, limit: $limit, cursor: $cursor, isNSFW: $isNSFW, mediaType: $mediaType) {
        pageInfo {
          nextCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            displayName
            url
            urlThumbnail
            extension
            personaId
            inferenceId
          }
        }
      }
    }
  `,

  GET_MEDIA_PERSONA: `
    query GetMediaPersona($id: ID!) {
      mediaPersona(id: $id) {
        id
        name
        url
        urlThumbnail
        extension
        personaId
        isInDataset
      }
    }
  `,

  GET_MEDIA_INFERENCE: `
    query GetMediaInference($id: ID!) {
      mediaInference(id: $id) {
        id
        name
        displayName
        url
        urlThumbnail
        extension
        personaId
        inferenceId
      }
    }
  `,

  GET_INFERENCES: `
    query GetInferences($personaId: ID!, $limit: Int!, $cursor: String, $mediaType: String) {
      inferences(personaId: $personaId, limit: $limit, cursor: $cursor, mediaType: $mediaType) {
        pageInfo {
          nextCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            status
            personaId
            provider
            inputPrompt
            mediaType
            resolution
            cameraFixed
            mediaInference {
              id
              name
              displayName
              extension
              url
              urlThumbnail
              path
              pathThumbnail
              isHD
              duration
              createdAt
              personaId
              inferenceId
              userId
            }
          }
        }
      }
    }
  `,

  GET_INFERENCE: `
    query GetInference($id: String!) {
      inference(id: $id) {
        id
        status
        personaId
        provider
        inputPrompt
        mediaType
        resolution
        cameraFixed
        mediaInference {
          id
          name
          displayName
          extension
          url
          urlThumbnail
          path
          pathThumbnail
          isHD
          duration
          createdAt
          personaId
          inferenceId
          userId
        }
      }
    }
  `,
};
